import React from 'react';
import SectionTitle from '../../SectionTitle';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';

const Section2Title = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const title = (
    <>
      <span>{context.sectionNumbers.section2}</span>
      <span>. תאריכים רלוונטים</span>
    </>
  );

  return <SectionTitle title={title} ref={ref}/>;
});

export default Section2Title;
